import { Mesh, type MeshStandardMaterial } from 'three';
import { buildBrushFaces } from './brushGeometry';
import { buildDisplacementFaces } from './displacement';
import { type BrushFace, facesToGeometry } from './faces';
import type { BspReader } from './reader';

/** All collidable faces in the BSP: ride-surface brushes + displacement terrain. */
export function buildCollisionFaces(reader: BspReader): BrushFace[] {
  return [...buildBrushFaces(reader), ...buildDisplacementFaces(reader)];
}

/** One merged collision Mesh (brushes + displacements), world-space. */
export function buildCollisionMesh(reader: BspReader, material: MeshStandardMaterial): Mesh {
  const mesh = new Mesh(facesToGeometry(buildCollisionFaces(reader)), material);
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  return mesh;
}
